import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const Hero = ({ onStart }) => {
  return (
    <section className="relative flex min-h-[92vh] flex-col justify-center px-6 md:px-12 lg:px-20">
      <div className="mx-auto w-full max-w-6xl">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-sans text-sm uppercase tracking-[0.5em] text-[#1C1C1C]"
          data-testid="hero-brand"
        >
          DIRGA
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-8 max-w-4xl font-serif text-5xl font-light leading-[1.05] tracking-tight text-[#1C1C1C] sm:text-6xl lg:text-7xl"
        >
          Build Your Wedding Story
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.22 }}
          className="mt-8 max-w-xl font-serif text-xl italic text-[#5C5C5C] sm:text-2xl"
        >
          Choose the moments that matter. Create your own package.
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.32 }}
          className="mt-6 max-w-md font-sans text-sm leading-relaxed text-[#8A8A8A]"
        >
          Pilih layanan yang kamu butuhkan dan lihat estimasi biayanya secara langsung.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.44 }}
          className="mt-12"
        >
          <button
            type="button"
            data-testid="hero-start-btn"
            onClick={onStart}
            className="group inline-flex items-center gap-3 bg-[#1C1C1C] px-8 py-4 font-sans text-sm uppercase tracking-widest text-white transition-colors duration-300 hover:bg-[#333333]"
          >
            Start Building
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </motion.div>
      </div>

      <div className="pointer-events-none absolute bottom-8 left-1/2 -translate-x-1/2 font-sans text-[10px] uppercase tracking-[0.4em] text-[#B9B2A4]">
        Wedding Photography &amp; Videography
      </div>
    </section>
  );
};
